import {inject, injectable} from "inversify";
import {Sponsor} from "@/modules/sponsoring/entity";
import chance from "@/modules/base/services/chance";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {SponsorTypeEnum} from "@/modules/sponsoring/enums";

@injectable()
export default class SponsorFactory {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository
  ) {
  }

  private getRandom(range: number) {
    return chance.integer({min: 100 - range / 2, max: 100 + range / 2}) / 100;
  }

  public async generate(prestige: number, type: SponsorTypeEnum): Promise<Sponsor> {
    const randomRange = this.configRepository.get('sponsoring.randomPercentRange');
    const factory = this.configRepository.get('sponsoring.prestigeFactor');
    const types = this.configRepository.get('sponsoring.types');

    const sponsor = new Sponsor();
    sponsor.type = type;
    sponsor.name = chance.company();
    sponsor.once = factory * prestige * types[type].once * this.getRandom(randomRange);
    sponsor.perLeagueMatch = factory * prestige * types[type].perLeagueMatch * this.getRandom(randomRange);
    sponsor.perLeagueVictory = factory * prestige * types[type].perLeagueVictory * this.getRandom(randomRange);
    sponsor.perCupMatch = factory * prestige * types[type].perCupMatch * this.getRandom(randomRange);
    sponsor.perCupVictory = factory * prestige * types[type].perCupVictory * this.getRandom(randomRange);

    await sponsor.save();

    return sponsor;
  }
}
